import pick from 'lodash/pick';
import omit from 'lodash/omit';

export const getUnknownProps = (props, component) => omit(props, Object.keys(component.propTypes));

export const getValidDOMProps = (props, component) => {
  const unknownProps = getUnknownProps(props, component);
  return pick(unknownProps, ['id', 'style', 'className', 'title', 'tabIndex']);
};



// WEBPACK FOOTER //
// ./node_modules/@localytics/loc-components/lib/Utils/reactprops.js